export default __webpack_public_path__ + "static/media/carnet.1899a481.png";